export default "__VITE_ASSET__CO05ENcB__"